{
  "id": "campaign-043",
  "name": "Dewy Meadow",
  "seed": "campaign:43",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRRR.......",
    "RRRRR.......",
    "_____.......",
    "............",
    "............",
    ".y.yc..cy.y.",
    "....c..c....",
    "....c..c....",
    "fffff..fffff",
    "............",
    ".#..........",
    "..y.....~y.x",
    ".......~....",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 10,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 4
    },
    {
      "kind": "repair",
      "x": 11,
      "y": 10
    }
  ],
  "generatorVersion": 3,
  "level": 43,
  "biome": "farm",
  "par": {
    "reel": 5280,
    "push": 4576,
    "selfPropelled": 4200,
    "tractor": 3880,
    "zeroTurn": 3035,
    "fairway": 1760
  },
  "routeTries": {
    "par": {
      "reel": 24,
      "push": 18,
      "selfPropelled": 18,
      "tractor": 0,
      "zeroTurn": 14,
      "fairway": 2
    }
  }
}
